import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.w47_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.x47_1 = LinkedHashMap().bc();
      }
      y47() {
        return this.x47_1;
      }
      y40() {
        // Inline function 'kotlin.apply' call
        this.w47_1.y40();
        return this;
      }
      z40() {
        // Inline function 'kotlin.apply' call
        this.w47_1.z40();
        return this;
      }
      t40() {
        // Inline function 'kotlin.apply' call
        this.w47_1.t40();
        return this;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        this.w47_1.u40();
        return this;
      }
      v47(name) {
        // Inline function 'kotlin.apply' call
        this.w47_1.v47(name);
        return this;
      }
      f41(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.f41(value);
        return this;
      }
      p41(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.p41(value);
        return this;
      }
      k41(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.k41(value);
        return this;
      }
      h41(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.h41(value);
        return this;
      }
      n41(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.n41(value);
        return this;
      }
      l4a(value) {
        // Inline function 'kotlin.apply' call
        this.w47_1.l4a(value);
        return this;
      }
      u41(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.x47_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.w47_1.a4a();
        tmp0.x4(key, value);
        this.w47_1.y3z();
        return this;
      }
      y3z() {
        // Inline function 'kotlin.apply' call
        this.w47_1.y3z();
        return this;
      }
      a4a() {
        return this.w47_1.a4a();
      }
      l6() {
        this.w47_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
